/**
 * Runtime immutability helpers.
 *
 * The kernel "returns frozen, immutable values" (MathToolImplementation.md §3 /
 * §1). A `ReadonlySet` gives compile-time immutability, but `Object.freeze` does
 * NOT stop `Set.prototype.add/delete/clear` (those touch an internal slot, not a
 * frozen own-property). So a Config returned by the kernel additionally has its
 * mutators replaced with throwing stubs and is then frozen — genuine runtime
 * immutability, defence-in-depth behind the readonly type.
 */
function blocked(method) {
    throw new TypeError(`@progression/core: Config is immutable; .${method}() is not allowed`);
}
/** Build a genuinely-immutable Config from any iterable of ids (deduped by Set). */
export function frozenConfig(ids) {
    const s = new Set(ids);
    Object.defineProperties(s, {
        add: { value: () => blocked('add'), enumerable: false, writable: false, configurable: false },
        delete: { value: () => blocked('delete'), enumerable: false, writable: false, configurable: false },
        clear: { value: () => blocked('clear'), enumerable: false, writable: false, configurable: false },
    });
    return Object.freeze(s);
}
/** Deep-freeze a value one or two levels deep (objects + their array fields). */
export function deepFreeze(value) {
    if (value !== null && typeof value === 'object') {
        for (const key of Object.keys(value)) {
            const v = value[key];
            if (Array.isArray(v))
                Object.freeze(v);
            else if (v !== null && typeof v === 'object')
                Object.freeze(v);
        }
    }
    return Object.freeze(value);
}
//# sourceMappingURL=immutable.js.map